import { IServerTariff } from 'types/tariff';

import { IFilters } from './interfaces';

export const filterTariffs =
  (tariffFilters: IFilters) =>
  (tariff: IServerTariff): boolean => {
    const {
      is_active,
      has_fixed_finish_time,
      use_global_discounts,
      host_group,
    } = tariffFilters;
    const flattedHostGroups = tariff.price_list
      .flatMap((priceList) => priceList.host_groups)
      .map((group) => group.id.toString());

    if (is_active && tariff.is_active !== is_active) {
      return false;
    }

    if (
      has_fixed_finish_time &&
      tariff.has_fixed_finish_time !== has_fixed_finish_time
    ) {
      return false;
    }

    if (
      use_global_discounts &&
      tariff.use_global_discounts !== use_global_discounts
    ) {
      return false;
    }

    if (host_group?.value) {
      if (!flattedHostGroups.includes(host_group.value as string)) {
        return false;
      }
    }

    return true;
  };

export const getSearchParams = ({
  is_active,
  use_global_discounts,
  host_group,
  has_fixed_finish_time,
}: IFilters): string =>
  `?is_active=${is_active}&has_fixed_finish_time=${has_fixed_finish_time}&use_global_discounts=${use_global_discounts}${
    host_group?.value ? `&host_group=${host_group.value}` : ''
  }`;
